<template>
  <div class='studyList'>
    <section class="banner inner-banner">
      <img :src="list.img">
    </section>
    <section class="w1200 re-s1">
      <div class="centerbox tab-slide centerbox tab-slide1">
        <a :class="tabIndex==0?'centerbox tab-a onthis':'centerbox tab-a'" @click="tabClick(0)">培训</a>
        <a :class="tabIndex==1?'centerbox tab-a onthis':'centerbox tab-a'" @click="tabClick(1)">课堂</a>
      </div>
    </section>
    <section class="news-list">
      <div class="w1200" v-show="tabIndex===0">
        <div class="list-ul">
          <a class="flexbox n-item align-start" 
             v-for='(item, index) in trainList.slice((currentPage - 1) * pagesize, currentPage * pagesize)' 
            :key='index' @click="goDetail(item.title,0)">
            <div class="new-vposter">
              <img :src="item.url">
            </div>
            <div class="text betweenbox columnbox">
              <span class="flexbox title">
                <h5>{{ item.title }}</h5>
              </span>
              <p class="des"></p>
              <span class="betweenbox bottom">
                了解详情&gt;&gt;
                <font>{{ item.time }}</font>
              </span>
            </div>
          </a>
        </div>
        <ul class="page-paginations centerbox">
          <el-pagination  @size-change="handleSizeChange"
              @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pagesize" background
              layout="prev, pager, next" :total="trainList.length">
            </el-pagination>
        </ul>
      </div>
      <div class="w1200" v-show="tabIndex===1">
        <div class="list-ul">
          <a class="flexbox n-item align-start" v-for="(item,index) in list.classroomList" :key="index" @click="goDetail(item.title,1)">
            <div class="new-vposter">
              <img :src="item.url">
            </div>
            <div class="text betweenbox columnbox">
              <span class="flexbox title">
                <h5>{{ item.title }}</h5>
              </span>
              <p class="des"></p>
              <span class="betweenbox bottom">
                了解详情&gt;&gt;
                <font>{{ item.time }}</font>
              </span>
            </div>
          </a>
        </div>
      </div>
    </section>
    <div style="display: flex;justify-content: center;padding: 30px 0;">
          <a class="return-a centerbox" style="" @click="backList()"><img src="../../assets/images/r-ico.png"> 返回创新研究院</a>
      </div>

  </div>
</template>

<script>
import axios from 'axios'
export default {
  metaInfo() {
    return {
      title: "培训-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {

  },
  data() {
    return {
      tabIndex:0,
      list:{},
      currentPage: 1,
      pagesize: 5,
      trainList:[]
    }
  },
  created() {
    this.getList()
  },
  // 监听导航下拉回收
  watch: {
  },
  methods: {
    getList(){
      let data = {
        Title: "教育列表",
        ForumTypeCode: "YCJYLB",
      };
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
           this.list = JSON.parse(res.data.OutputData.Content)
           this.trainList = this.list.trainList
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    tabClick(index){
      this.tabIndex = index
    },
    goDetail(title,type){
      this.$router.push({
        name:"studyListDetail",
        query:{
            title:title,
            type:type
        }
      })
    },
        // 返回列表
        backList() {
      this.$router.push({
        name:"jxResearchInstitute",
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/base.less";

.studyList {
  width: 100%;
  color: #333;
  line-height: 1.7;
  .w1200 {
    margin: 0 auto;
    display: block;
  }
  .banner {
    img {
      max-width: auto;
      min-width: 100%;
      height: auto;
      min-height: 100%;
      border: none;
      font-size: 0;
      outline-width: 0PX;
      vertical-align: top;
    }
  }

  .re-s1 {
    .tab-slide1 {
      a {
        color: #333;
        border: 1PX solid #1462b6;
        background-color: white;
        text-align: center;
      }
      a.onthis {
        color: white;
        background-color: #1462b6;
      }
    }
  }
  .news-list {
    .n-item {
      height: auto;
      width: 100%;
      .new-vposter {
        overflow: hidden;
        position: relative;
        background-color: #f7f8fb;
        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          min-width: 100%;
          min-height: 100%;
          max-width: 100%;
          border: none;
          font-size: 0;
          outline-width: 0PX;
          vertical-align: top;
        }
      }

      .text {
        border-bottom: 1PX dashed #d2d2d2;
        span {
          width: 100%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #458cff;
          font {
            color: #969696;
          }
        }
        span.title h5 {
          font-weight: normal;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #458cff;
          line-height: 3;
        }
        p.des {
          width: 100%;
          text-align: justify;
          line-height: 1.5;
          color: #a8a8a8;
        }
      }
    }
    .n-item:hover span,
    .n-item:hover span.title h5 {
      color: #007edd;
    }
  }


  @media only screen and (min-width: 960px) {
    .banner {
      padding-top: 130PX;
    }
    .w1200 {
      width: 1200PX;
      height: 100%;
      display: block;
    }
    .re-s1 {
      .tab-slide1 {
        height: 125PX;
        a {
          padding: 0 20PX;
          font-size: 26PX;
          line-height: 54PX;
          width: 220PX;
        }
      }
    }
    .news-list {
      padding-bottom: 40PX;
      .list-ul {
        padding-top: 12PX;
        padding-bottom: 40PX;
        .n-item {
          margin-bottom: 24PX;
          .new-vposter {
            width: 350PX;
            padding-bottom: 212PX;
            height: 0;
          }
          .text {
            width: calc(100% - 350PX);
            height: 236PX;
            padding-left: 36PX;
            padding-top: 24PX;
            padding-bottom: 24PX;
            span {
              font-size: 14PX;
            }
            span.title h5 {
              font-size: 24PX;
            }
            p.des {
              margin-bottom: 20PX;
              font-size: 16PX;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width:959px) and (min-width:320px) {
    .banner {
      padding-top: 3.52rem;
    }
    .w1200 {
      width: 100%;
      padding-right: 1.44rem;
      padding-left: 1.44rem;
    }
    .re-s1 {
      .tab-slide1 {
        height: 5rem;
        a {
          padding: 0 .8rem;
          font-size: 1.04rem;
          line-height: 2;
          width: 50%;
        }
      }
    }
    .news-list {
      padding-bottom: 2rem;
      .list-ul {
        padding-top: 12PX;
        padding-bottom: 20PX;
        .n-item {
          height: auto;
          width: 100%;
          -webkit-box-orient: vertical;
          -webkit-box-direction: normal;
          -ms-flex-flow: column;
          flex-flow: column;
          margin-bottom: 1.44rem;
          .new-vposter {
            width: 100%;
            padding-bottom: 60.57%;
          }
          .text {
            width: 100%;
            height: auto;
            padding-top: 0.96rem;
            padding-bottom: 0.96rem;
            border-bottom: 1PX dashed #d2d2d2;
            padding-left: 0;
            span {
              font-size: .96rem;
            }
            span.title h5 {
              font-size: 1.12rem;
            }
            p.des {
              margin-bottom: 1.6rem;
              font-size: .96rem;
            }
          }
        }
      }
    }
  }
}
</style>